import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { whySbdc } from "@/mocks/clinic";

export default function WhySbdc() {
  return (
    <section className="bg-background-100 py-24 md:py-32 lg:py-40">
      <div className="u-container">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
          <Reveal>
            <div className="lg:sticky lg:top-32">
              <SectionHeading en={whySbdc.headingEn} jp={whySbdc.headingJp} />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <ul className="border-t border-foreground-950/12">
              {whySbdc.items.map((item) => (
                <li
                  key={item.no}
                  className="group flex flex-col gap-4 border-b border-foreground-950/12 py-8 transition-colors sm:flex-row sm:items-baseline sm:gap-10 md:py-10"
                >
                  <span className="font-label text-2xl font-light tracking-[0.15em] text-secondary-500 transition-colors group-hover:text-accent-600 md:text-3xl">
                    {item.no}
                  </span>
                  <div className="flex-1">
                    <h3 className="font-heading text-lg text-foreground-950 md:text-xl">{item.title}</h3>
                    <p className="mt-4 max-w-[46rem] text-[14px] leading-[1.9] text-foreground-700 md:text-[15px] md:leading-[2] lg:text-[16px]">{item.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}